/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOvalVerticalFilled = createReactComponent("filled", "oval-vertical-filled", "IconOvalVerticalFilled", [["path", { "d": "M12 5c-5.457 0 -10 3.028 -10 7s4.543 7 10 7s10 -3.028 10 -7s-4.543 -7 -10 -7z", "key": "svg-0" }]]);

export { IconOvalVerticalFilled as default };
//# sourceMappingURL=IconOvalVerticalFilled.mjs.map
